import UserManagementPage from './views/user-management-page';
import PemakaianNolPage from './views/pemakaian-nol-page';
import DashboardPage from './views/dashboard-page';
import auth from "./auth";
import { createRouter, createWebHashHistory } from "vue-router";

import Home from "./views/home-page";
//import Profile from "./views/profile-page";
//import Tasks from "./views/tasks-page";
import defaultLayout from "./layouts/side-nav-inner-toolbar";
import simpleLayout from "./layouts/single-card";

function loadView(view) {
  return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: [1,2,3],
      },
      component: Home
    },
    /*
    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },
    {
      path: "/tasks",
      name: "tasks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Tasks
    },*/
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "CETUNG",
        description: "CEK DATA TUNGGAKAN",
      },
      component: loadView("login-form")
    },/*
    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Reset Password",
        description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
      },
      component: loadView("reset-password-form")
    },
    {
      path: "/create-account",
      name: "create-account",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign Up"
      },
      component: loadView("create-account-form"),
    },
    {
      path: "/change-password/:recoveryCode",
      name: "change-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Change Password"
      },
      component: loadView("change-password-form")
    },*/
    {
      path: "/",
      redirect: "/home"
    },/*
    {
      path: "/recovery",
      redirect: "/home"
    },*/
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    }, 
    {
      path: "/dashboard-page",
      name: "dashboard-page",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: [1,3],
      },
      component: DashboardPage
    }, 
    {
      path: "/pemakaian-nol-page",
      name: "pemakaian-nol-page",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: [1,3],
      },
      component: PemakaianNolPage
    }, 
    {
      path: "/user-management-page",
      name: "user-management-page",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: [1,3],
      },
      component: UserManagementPage
    }
  ],
  history: createWebHashHistory()
});
// In your beforeEach navigation guard
router.beforeEach(async (to, from, next) => {
  var isLoggedIn = await auth.loggedIn();
  //var userRole = isLoggedIn ? auth._user.role_id : null;
  var userRole = auth.getUserRoleId();

  if (to.name === "login-form" && isLoggedIn) {
    next({name: "home"});
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({
        name: "login-form",
        query: {redirect: to.fullPath}
      });
    } else {
      // If the route requires certain roles
      if (to.matched.some(record => record.meta.requiredRoles)) {
        // Check if user has necessary role
        if (to.matched.some(record => record.meta.requiredRoles.includes(userRole))) {
          next();
        } else {
          next({name: "home"}); // Redirect to home or any other page
        }
      } else {
        next();
      }
    }
  } else {

    next();
  }
});

export default router;